import { Controller, useFormContext } from 'react-hook-form'

import { CheckBox, FF2 } from 'ui/components'
import { SarEdit } from '~bank-bsa-reporting/types'

export const AmountUnknown = () => {
  const { control, setValue, clearErrors } = useFormContext<SarEdit>()
  return (
    <Controller
      name="suspiciousActivityInfo.amountUnknown"
      control={control}
      render={({ field }) => (
        <FF2
          field={field}
          input={(props) => (
            <CheckBox
              {...props}
              checkBoxLabel="Amount Unknown"
              onChange={(value) => {
                if (value) {
                  setValue('suspiciousActivityInfo.noAmountInvolved', false)
                  clearErrors('suspiciousActivityInfo.currentAmount')
                }
                field.onChange(value)
              }}
            />
          )}
        />
      )}
    />
  )
}
